import {
    UPDATE_LANGUAGE_START,
    UPDATE_LANGUAGE_SUCCESS,
    UPDATE_LANGUAGE_ERROR
} from '../../../constants';
import { updateLanguageStatus, updateDefaultLanguage } from '../../../lib/graphql'
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { getActiveLanguages } from '../../../helpers/GetDynamicItemName/getDynamicName';

export function updateMobileLanguageStatus(id, isEnable) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: UPDATE_LANGUAGE_START
        });
        try {

            const { data } = await client.mutate({
                mutation: updateLanguageStatus,
                variables: { id, isEnable },
            });

            if (data && data.updateLanguageStatus && data.updateLanguageStatus.status == 200) {
                dispatch({
                    type: UPDATE_LANGUAGE_SUCCESS
                });
                await dispatch((getActiveLanguages()))
                showToaster({ messageId: 'smtpActiveStatus', toasterType: 'success' })
                return true;
            } else {
                dispatch({
                    type: UPDATE_LANGUAGE_ERROR
                });
                showToaster({ messageId: 'commonError', requestMessage: data?.updateLanguageStatus?.errorMessage, toasterType: 'error' });
                return false;
            }

        } catch (error) {
            dispatch({
                type: UPDATE_LANGUAGE_ERROR
            });
            showToaster({ messageId: 'updateFailed', toasterType: 'error' });
            return false;
        }
    }
}

export function updateDefaultMobileLanguage(id) {

    return async (dispatch, getState, { client }) => {
        dispatch({
            type: UPDATE_LANGUAGE_START
        });
        try {

            const { data } = await client.mutate({
                mutation: updateDefaultLanguage,
                variables: { id },
            });

            if (data && data.updateDefaultLanguage && data.updateDefaultLanguage.status == 200) {
                dispatch({
                    type: UPDATE_LANGUAGE_SUCCESS
                });
                showToaster({ messageId: 'smtpActiveStatus', toasterType: 'success' })
                return true;
            } else {
                dispatch({
                    type: UPDATE_LANGUAGE_ERROR
                });
                showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.updateDefaultLanguage?.errorMessage })
                return false;
            }

        } catch (error) {
            dispatch({
                type: UPDATE_LANGUAGE_ERROR
            });
            showToaster({ messageId: 'updateFailed', toasterType: 'error' });
            return false;
        }
    }
}